import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");

  const _component_FooterMusci = _resolveComponent("FooterMusci");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view), _withDirectives(_createVNode(_component_FooterMusci, null, null, 512), [[_vShow, _ctx.$store.state.isFooterMusic]])], 64);
}